const constants = {
  MAX_LENGTH_CONSTRAINTS: {
    ADD_PRO_NOTES: {
      COMMENT: 6000
    }
  },
  CUSTOMER_LIST_COLLAPSED_COUNT: 3
};

export default constants;
